import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import "../../assets/styles/Service Layout Css/ServicesLayoutCss.css"; // Import external CSS file for transitions
import {
  FaLock,
  FaBox,
  FaProjectDiagram,
  FaCode,
  FaCogs,
  FaBoxOpen,
  FaTrash,FaList,FaPlus,FaTags,FaLink
} from "react-icons/fa";
const ServicesLayout = () => {
  const location = useLocation();

  return (
    <div>
      <div className="p-[30px] border-b border-gray-200 w-full font-inter">
        <h1 className="text-2xl font-semibold text-[#667085]">Services</h1>
      </div>
      <div>
        <div className="flex gap-[40px] py-[20px] ps-[30px] font-inter">
          <NavLink
            to="all-services"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaList /> All Services List
          </NavLink>

          <NavLink
            to="add-services"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaPlus /> Add Service
          </NavLink>

          <NavLink
            to="services-category-management"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaTags /> Category Management
          </NavLink>

          <NavLink
            to="services-hsn-management"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaCode /> SAC Management
          </NavLink>

          <NavLink
            to="services-unit-settings"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaCogs /> Unit Settings
          </NavLink>

          <NavLink
            to="related-services-settings"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaLink /> Related Service Settings
          </NavLink>

          <NavLink
            to="services-trash"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
            }
          >
            <FaTrash /> Trash
          </NavLink>
        </div>

        <div className="py-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ServicesLayout;
